import { render, staticRenderFns } from "./FooterComponentT4a.vue?vue&type=template&id=3147cd2c&scoped=true"
import script from "./FooterComponentT4a.vue?vue&type=script&lang=ts"
export * from "./FooterComponentT4a.vue?vue&type=script&lang=ts"
import style0 from "./FooterComponentT4a.vue?vue&type=style&index=0&id=3147cd2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3147cd2c",
  null
  
)

export default component.exports